// QuestionSelector.tsx
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Question, QuestionCategory } from "../../types";
import { useAppDispatch } from "../../app/store";

interface QuestionSelectorProps {
  questionCategories: QuestionCategory[];
  availableQuestions: Record<number, { data: Question[] }>;
  selectedQuestions: number[];
  handleChangeCat: (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => void;
  handleQuestionSelect: (questionId: number) => void;
  textBoxes1: string[];
  textBoxes: string[];
  setTextBoxes: React.Dispatch<React.SetStateAction<string[]>>;
  addTextBox: () => void;
  removeTextBox: (index: number) => void;
  setTextBoxes1: React.Dispatch<React.SetStateAction<string[]>>;
  employeeQuestions: string[];
  onEmployeeQuestionChange: (index: number, value: string) => void;
  onAddEmployeeQuestion: () => void;
  onRemoveEmployeeQuestion: (index: number) => void;
  currentPart?: number;
  setCurrentPart?: React.Dispatch<React.SetStateAction<number>>;
}

const QuestionSelector: React.FC<QuestionSelectorProps> = ({
  questionCategories,
  availableQuestions,
  selectedQuestions,
  handleChangeCat,
  handleQuestionSelect,
  textBoxes1,
  addTextBox,
  setTextBoxes1,
  employeeQuestions,
  onEmployeeQuestionChange,
  onRemoveEmployeeQuestion,
  currentPart,
  setCurrentPart,
}) => {
  const addTextBox1 = () => {
    setTextBoxes1((prev) => [...prev, ""]);
  };

  const removeTextBox1 = (index: number) => {
    setTextBoxes1((prev) => prev.filter((_, i) => i !== index));
  };

  const dispatch = useAppDispatch();

  return (
    <Row>
      {currentPart === 1 && (
        <Col md={8} sm={12}>
          <h6>Employee Questions</h6>
          {employeeQuestions.map((question, index) => (
            <div key={index} className="mb-3">
              <div className="d-flex align-items-center mb-2">
                <input
                  type="text"
                  value={question}
                  onChange={(e) =>
                    onEmployeeQuestionChange(index, e.target.value)
                  }
                  className="form-control me-2 rounded-0"
                />
              </div>
              <div className="d-flex justify-content-end">
                <span
                  className="text-danger float-end border-0"
                  style={{ cursor: "pointer" }}
                  onClick={() => onRemoveEmployeeQuestion(index)}
                >
                  - remove
                </span>
              </div>
            </div>
          ))}
          <hr className="hr" />
          <div className="mb-3">
            <span
              className="text-secondary border-0"
              onClick={addTextBox}
              style={{ cursor: "pointer" }}
            >
              + Add Question
            </span>
          </div>
        </Col>
      )}
      {currentPart === 2 && (
        <Col md={8} sm={12} className="mb-3 mt-3">
          <h5>Screener Questions</h5>
          {textBoxes1.map((textBox1, index) => (
            <div key={index}>
              <select
                className="form-control rounded-0 w-100 mb-2"
                value={textBox1}
                onChange={(e) => handleChangeCat(e, index)}
              >
                <option value="" disabled>
                  Select question category
                </option>
                {questionCategories.map((cats) => (
                  <option key={cats.id} value={cats.id}>
                    {cats.category_name}
                  </option>
                ))}
              </select>

              {availableQuestions[parseInt(textBox1)] && (
                <div className="mt-2 w-100">
                  {availableQuestions[parseInt(textBox1)].data.map(
                    (question) => (
                      <div key={question.id} className="mb-2">
                        <input
                          type="checkbox"
                          className="form-check-input me-2"
                          id={`question-${question.id}`}
                          value={question.id}
                          checked={selectedQuestions.includes(question.id)}
                          onChange={() => handleQuestionSelect(question.id)}
                        />
                        <label htmlFor={`question-${question.id}`}>
                          {question.jobQuestion}
                        </label>
                      </div>
                    )
                  )}
                </div>
              )}

              <div className="d-flex justify-content-end mt-2 mb-3">
                <span
                  className="bi bi-dash text-danger"
                  onClick={() => removeTextBox1(index)}
                  style={{ cursor: "pointer" }}
                >
                  remove
                </span>
              </div>
            </div>
          ))}
          <hr className="hr" />
          <span
            className="bi bi-plus text-secondary"
            onClick={addTextBox1}
            style={{ cursor: "pointer" }}
          >
            add category
          </span>
        </Col>
      )}
    </Row>
  );
};

export default QuestionSelector;
